import { type FC } from "react";

const GUIDE_URL = "/guida-admin-qrflow.html";

const GuidePage: FC = () => {
    const handleOpenNewTab = () => {
        window.open(GUIDE_URL, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="animate-fade-in" style={{ height: "calc(100vh - 8rem)", minHeight: 500, display: "flex", flexDirection: "column" }}>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
                <div>
                    <h1 className="text-2xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-400">
                        Guida Amministratore
                    </h1>
                    <p className="text-slate-400 mt-1 text-sm md:text-base">Manuale operativo della piattaforma QR Flow</p>
                </div>
                <button
                    onClick={handleOpenNewTab}
                    className="flex items-center gap-2 px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white text-sm font-semibold rounded-xl border border-slate-700 transition-colors flex-shrink-0"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                        <polyline points="15 3 21 3 21 9"/>
                        <line x1="10" y1="14" x2="21" y2="3"/>
                    </svg>
                    Apri in nuova scheda
                </button>
            </div>

            <div className="flex-1 rounded-2xl overflow-hidden border border-slate-700/50 shadow-xl bg-slate-900">
                <iframe
                    src={GUIDE_URL}
                    title="Guida Amministratore QR Flow"
                    className="w-full h-full"
                    style={{ border: 0, display: "block" }}
                />
            </div>
        </div>
    );
};

export default GuidePage;
